module.exports = __webpack_public_path__ + "static/img/ind4.500b2f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/indicadores/ind4.png
// module id = S4jV
// module chunks = 3